import { useEffect } from "react";
import { Link } from "react-router-dom";

export const LegalLayout = ({ title, updated, children, testId }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen grid-bg py-24 px-6" data-testid={testId}>
      <div className="max-w-[820px] mx-auto">
        <Link to="/" className="mono text-[11px] tracking-[0.2em] text-[var(--accent)] hover:text-white transition-colors" data-testid="legal-back-link">
          ← BACK TO HOME
        </Link>
        <h1 className="h1-display text-[clamp(32px,4vw,54px)] mt-8 mb-3">{title}</h1>
        <p className="mono text-[10px] text-white/30 mb-12">LAST UPDATED: {updated}</p>
        <div className="legal-body space-y-8">{children}</div>
        <div className="mt-12 glass-card p-7" data-testid="legal-contact-card">
          <h2 className="font-black uppercase text-[17px] tracking-wide mb-3 text-white">Contact Us</h2>
          <p className="text-[14px] text-white/55 leading-[1.9]">
            Questions about this page, your information, or opting out? Reach us directly:
            <br />Darren Gussick — NEXA Mortgage LLC
            <br />Phone: <a href="tel:4075505795" className="text-[var(--accent)] hover:underline">407-550-5795</a>
            <br />Email: <a href="mailto:dgussick@nexalending.com" className="text-[var(--accent)] hover:underline">dgussick@nexalending.com</a>
            <br />Website: <a href="https://webinar.darrengussick.com/" target="_blank" rel="noreferrer" className="text-[var(--accent)] hover:underline">webinar.darrengussick.com</a>
          </p>
        </div>
        <div className="mt-16 pt-8 border-t border-white/[0.08] text-[11px] text-white/35 leading-relaxed">
          Darren Gussick NMLS# 122481 · NEXA Mortgage LLC NMLS# 1660690 · Licensed in Florida, Texas &amp; Pennsylvania · Equal Housing Opportunity
          <br />Contact: 407-550-5795 · dgussick@nexalending.com
        </div>
      </div>
    </div>
  );
};

export const H = ({ children }) => <h2 className="font-black uppercase text-[17px] tracking-wide mb-3 text-white">{children}</h2>;
export const P = ({ children }) => <p className="text-[14px] text-white/55 leading-[1.8]">{children}</p>;
